import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentRenewal: null,
    error: null,
    loading: false
};

const memberRenewalSlice = createSlice({
    name: 'memberRenewal',
    initialState,
    reducers: {
        setCurrentRenewal: (state, action) => {
            state.currentRenewal = action.payload;
        },
        clearCurrentRenewal: (state) => {
            state.currentRenewal = null;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        }
    }
});

export const {
    setCurrentRenewal,
    clearCurrentRenewal,
    setError,
    setLoading
} = memberRenewalSlice.actions;

export default memberRenewalSlice.reducer;
